export enum SheetThickness {
  LessOrEqualThanOneMillimeter = '<= 1mm',
  EqualToOnePointFiveMillimeter = '1,5mm',
  EqualToTwoMillimeter = '2mm',
  GreaterThanTwoMillimeter = '> 2mm',
}
